module.exports = __webpack_public_path__ + "static/media/4.fcad77b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/九宫格未选中态/4.png
// module id = 1622
// module chunks = 0